import API from "./../../utils/GlobalAPI";
import { ReviewProp } from "../Review/ReviewCards";

export interface UserProp {
  confirmed?: boolean;
  blocked?: boolean;
  _id: string;
  bio?: string;
  github_url?: string;
  instagram_url?: string;
  username: string;
  full_name?: string;
  email: string;
  provider?: string;
  createdAt?: string;
  updatedAt?: string;
  role?: any;
  reviews?: Array<ReviewProp>;
  orders?: any;
  id: string;
  avatar_url?: string;
}

export async function getUserById(id: string) {
  try {
    const data = await API.getMethod(`users/${id}`);
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getMe() {
  try {
    const data = await API.getMethod(`users/me`);
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getTalent() {
  try {
    const data: any = await API.getMethod("users");

    let talents = data.filter((user: any) => {
      return user.orders.length !== 0 && user.projects.length !== 0;
    });

    return talents;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getTalentByUsername(username: string) {
  try {
    const data: any = await API.getMethod(`users?username=${username}`);

    let talentData = {
      id: data[0].id,
      email: data[0].email,
      avatar_url: data[0].avatar_url,
      bio: data[0].bio,
      createdAt: data[0].createdAt,
      github_url: data[0].github_url,
      instagram_url: data[0].instagram_url,
      projects: data[0].projects,
      full_name: data[0].full_name,
    };
    return talentData;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function updateUser(id: string, userdata: any) {
  try {
    const data = await API.putMethod(`users/${id}`, userdata);
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}
